module.exports = {
	"accounts": {
		"bank": {
			"bank": "banking information",
			"details": "Detail of the account holder",
			"kyc": "Identity verification",
			"kycStatus": {
				"CREATED": "Ongoing validation",
				"REFUSED": "Denied: {refused_reason_message}",
				"VALIDATED": "Valid",
				"VALIDATION_ASKED": "Ongoing validation"
			},
			"labels": {
				"AddressLine1": "Street",
				"City": "City",
				"Country": "Country",
				"PostalCode": "Postal code",
				"Region": "Region",
				"bic": "BIC",
				"first_name": "First name",
				"iban": "IBAN",
				"kyc": "ID or passport",
				"last_name": "Last name"
			},
			"save": "Save"
		},
		"informations": {
			"additional": "Further information",
			"additionalText": "This information is required to validate your account",
			"address": "My address",
			"addressText": "This information is needed to verify your account and billing",
			"labels": {
				"AddressLine1": "Street",
				"City": "City",
				"Country": "Country",
				"PostalCode": "Postal code",
				"Region": "Region",
				"birthday": "Date of Birth",
				"country_of_residence": "country of residence",
				"email": "E-mail",
				"first_name": "First name",
				"income_range": "earnings",
				"last_name": "Last name",
				"nationality": "Nationality",
				"occupation": "Profession",
				"phone": "Phone number",
				"password": "New password"
			},
			"save": "Save"
		},
		"profile": {
			"labels": {
				"avatar": "Profile Photo",
				"cover": "Cover picture",
				"description": "Description",
				"jobTitle": "Job",
				"keywords": "Keywords related to your activity separated by commas",
				"languages": "My languages",
				"nickname": "Display name for clients",
				"offerId": "Front Offer",
				"offerTitle": "Title of the action button",
				"offerSwitch": "Internal offer",
				"offerLink": "Link of the offer",
				"resume": "Summary of Your Profile",
				"video": "Add a video"
			},
			"offer": "Front Offer",
			"private": "[Private]",
			"save": "Save",
			"valid": "Validate"
		},
		"schedule": {
			"add": "Add a new niche",
			"addThis": "Add this niche",
			"addTitle": "Add a niche",
			"header": {
				"day": "Day",
				"from": "Of",
				"to": "AT"
			},
			"labels": {
				"timezone": "Time zone"
			},
			"save": "Save",
			"title": "My schedules telephone availability"
		}
	},
	"activities": {
		"reason": {
			"ALERT": "{amount} {currency} within {timeframe} days"
		},
		"type": {
			"ALERT": "Alert for {nickname}",
			"LOCK": "{nickname} blocked",
			"MINUTES": "{nickname} received {minutes} minutes",
			"REFUND": "Refund for {nickname}",
			"RISKY": "{nickname} monitored",
			"UNLOCK": "{nickname} unlocked",
			"UNRISKY": "{nickname} unguarded"
		}
	},
	"applicationmenu": {
		"menu": {
			"customers": "Clients",
			"dashboard": {
				"accounts": "Accounts",
				"availabilities": "availability",
				"default": "Dashboards",
				"gains": "my earnings",
				"revenues": "Income Platform",
				"statistics": "Statistics",
				"todo": "My tasks",
				"traffic": "Traffic Platform"
			},
			"feedbacks": {
				"accepted": "accepted",
				"default": "view",
				"pending": "Waiting",
				"rejected": "rejected"
			},
			"messenger": "Send a message",
			"pages": {
				"default": "contents"
			},
			"purchases": "Sales",
			"services": {
				"create": "new offer",
				"default": "Offers",
				"private": "private",
				"promotions": "Specials",
				"public": "public"
			},
			"settings": {
				"account": "information",
				"bank": "Bank",
				"customization": "personalization",
				"default": "Settings",
				"links": "Smart links",
				"platform": "Profile",
				"schedule": "Hours",
				"subscription": "Subscription",
				"team": "Team",
				"transfers": "transfers"
			}
		}
	},
	"applicationtoolbar": {
		"edit": "My profile",
		"finishPause": "Finish my break",
		"logout": "Sign out",
		"pause": "I pause",
		"resolveSubscription": "Set my subscription"
	},
	"availabilities": {
		"exepertsperday": {
			"header": {
				"expert": "Expert"
			}
		},
		"expertsperweek": {
			"available": "Maximum Availability ({maxHour} h / 24)",
			"header": {
				"day": [
					"Sunday",
					"On Monday",
					"Tuesday",
					"Wednesday",
					"Thursday",
					"Friday",
					"Saturday"
				],
				"expert": "Expert",
				"total": "Total"
			},
			"notAvailable": "Unavailable"
		}
	},
	"calltimeline": {
		"state": {
			"busy": "Busy",
			"completed": "Finished",
			"failed": "Failed",
			"in-progress": "Call in progress",
			"no-answer": "No answer",
			"queued": "Waiting",
			"ringing": "Alarm"
		}
	},
	"cardform": {
		"labels": {
			"cvx": "security code",
			"month": "Month",
			"number": "Card number",
			"year": "Year"
		},
		"save": "Add my card",
		"title": "Add a map"
	},
	"charts": {
		"averageTime": {
			"label": "Average time spent"
		},
		"gains": {
			"label": "Earnings"
		},
		"newvsreturning": {
			"new": "new visitors",
			"returning": "repeat visitors",
			"title": "Distribution of types of offers"
		},
		"offerrevenue": {
			"label": "Revenue deals",
			"mail": "Mail",
			"prepaid_minute": "Flat rate",
			"product": "Product",
			"service": "Service"
		},
		"offertyperevenue": {
			"availability": "Cat",
			"mail": "Mail",
			"prepaid_minute": "Flat rate",
			"product": "Product",
			"service": "Service",
			"title": "Distribution of types of offers"
		},
		"purchases": {
			"label": "earnings"
		},
		"sessions": {
			"label": "Number of visits"
		}
	},
	"dashboard": {
		"averagetimespent": {
			"notActivated": "Your statistics are not yet activated",
			"title": "Average time spent"
		},
		"gains": {
			"title": "In the last month"
		},
		"gainssum": {
			"title": "Total"
		},
		"newvsreturning": {
			"notActivated": "Your statistics are not yet activated",
			"title": "Division"
		},
		"offerrepartition": {
			"title": "For deals"
		},
		"offertyperepartition": {
			"title": "By type of offer"
		},
		"purchases": {
			"title": "In the last month"
		},
		"purchasessum": {
			"title": "Total"
		},
		"sessions": {
			"notActivated": "Your statistics are not yet activated",
			"title": "Visits last month"
		}
	},
	"dateintervalpicker": {
		"dates": [
			"Of",
			"at"
		]
	},
	"expert": {
		"header": {
			"confirmation": "Are you sure you want to delete this expert?",
			"connect": "Log into account",
			"delete": "Remove This expert",
			"more": "stock",
			"profile": "View profile"
		},
		"profile": {
			"item": {
				"createdAt": "Join the",
				"email": "E-mail",
				"firstName": "First name",
				"lastName": "Last name",
				"nickname": "Pseudo",
				"phone": "Phone"
			},
			"none": "-",
			"subtitles": {
				"contact": "Contact information",
				"personal": "Personal informations"
			}
		},
		"purchases": {
			"title": "completed services"
		},
		"schedule": {
			"days": [
				"Sunday",
				"On Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			],
			"header": {
				"day": "Day",
				"from": "of",
				"to": "at"
			},
			"timezone": "Time zone",
			"title": "Hours"
		}
	},
	"feedbackactions": {
		"accept": "Publish",
		"cancel": "To cancel",
		"comment": "Comment",
		"reject": "To reject",
		"save": "Save",
		"saveAndPublish": "Save and publish",
		"update": "Edit"
	},
	"feedbackcontent": {
		"by": "Through :",
		"date": "The :"
	},
	"feedbackform": {
		"labels": {
			"content": "contents",
			"note": "Note",
			"response": "Reply"
		}
	},
	"formatters": {
		"errorcode": {
			"code": {
				"101001": "The user does not complete the transaction",
				"101002": "The transaction was canceled by the user",
				"101101": "Transaction refused by the bank (not honor)",
				"101102": "Transaction refused by the bank (Amount limit)",
				"101103": "Transaction refused by the terminal",
				"101104": "Transaction refused by the bank (card limit reached)",
				"101105": "the card expired",
				"101106": "The card is inactive",
				"101111": "Maximum number of attempts reached",
				"101112": "Maximum amount exceeded",
				"101113": "exceeded maximum use",
				"101115": "Exceeding the speed limit",
				"101116": "Quantity limits",
				"101199": "transaction refused",
				"101301": "Secure mode: authentication failed 3DSecure",
				"101302": "Secure mode: the map is not associated with 3DSecure",
				"101303": "Secure mode: the card is not compatible with 3DSecure",
				"101304": "Secure mode: the authentication session expired 3DSecure",
				"101399": "Secure mode: authentication 3DSecure unavailable",
				"101410": "The card is not active",
				"105101": "Invalid card number",
				"105102": "Name of cardholder not valid",
				"105103": "Invalid PIN",
				"105104": "PIN format incorrect",
				"105202": "Card Number: invalid format",
				"105203": "Expiry date: missing or invalid format",
				"105204": "CVV: missing or invalid format",
				"105205": "callback URL: invalid format",
				"105206": "Recording information: invalid format",
				"105299": "token input error",
				"001001": "Insufficient Wallet Balance",
				"001002": "The author is not the owner of the wallet",
				"001011": "The transaction amount is greater than the maximum allowed",
				"001012": "The transaction amount is below the minimum amount allowed",
				"001013": "Invalid transaction amount",
				"001014": "CréditedFunds must be more than 0 (DebitedFunds can not match the costs)",
				"001030": "The user was not redirected",
				"001031": "User canceled payment",
				"001032": "The user fills in the details of the payment card",
				"001033": "The user has not been redirected then the payment session has expired",
				"001034": "The user has left the payment session expire without pay",
				"001401": "The transaction has already been paid successfully",
				"001599": "Token Processing Error",
				"001999": "Generic operation error",
				"002998": "Blocked due to limitations of the KYC bank account holder (maximum amount debited or credited reached)",
				"002999": "Blocked due to limitations of KYC of a Debtor (maximum amount debited or credited reached)",
				"005403": "The refund can not exceed the original amount of the transaction",
				"005404": "The reimbursed costs may not exceed the original amount of costs",
				"005405": "Insufficient customer expense of portfolio balance",
				"005407": "Duplicated operation: you can not repay the amount mê ... more than once for a transaction on the same day",
				"008001": "counterfeit card",
				"008002": "lost card",
				"008003": "stolen card",
				"008004": "unauthorized subrack",
				"008005": "Security breach",
				"008006": "Fraud suspected by the bank",
				"008007": "Opposition on bank account (Temporary)",
				"008500": "Transaction blocked by fraud policy",
				"008600": "Wallet blocked fraud policy",
				"008700": "Blocked by fraud policy",
				"008999": "fraud policy error",
				"009101": "PSP timeout please try tardr",
				"009103": "PSP configuration error",
				"009199": "Technical error PSP",
				"009499": "technical bank error",
				"009999": "technical error",
				"01902": "This card is not active",
				"02101": "internal error",
				"02624": "expired card",
				"02625": "Invalid card number",
				"02626": "Date invalid. Use mmdd size",
				"02627": "Invalid CCV number",
				"02628": "transaction refused",
				"02631": "Timeout",
				"02632": "GET method is not allowed",
				"09101": "Username / password incorrect",
				"09102": "The account is locked or inactive",
				"09104": "The client certificate is disabled",
				"09201": "You do not have permissions to make this API call"
			}
		},
		"minute": {
			"units": {
				"hour": "h",
				"minute": "min",
				"second": "dry"
			}
		}
	},
	"headerform": {
		"labels": {
			"actionHref": "Link button",
			"actionTitle": "Button title",
			"picture": "Background picture",
			"pictureForVideo": "Image to video",
			"subtitle": "Subtitle",
			"title": "title",
			"video": "Background Video"
		},
		"or": "or",
		"save": "Add",
		"title": "Add header"
	},
	"headersform": {
		"addHeader": "Add header",
		"title": "Headers of my site"
	},
	"inputs": {
		"availabilitytype": {
			"types": {
				"chat": "Cat"
			}
		},
		"category": {
			"categories": {
				"accounting": "Management Accounting",
				"achitecture": "Architecture & Design",
				"art": "Arts, Music, Culture",
				"body_care": "Body Care & Fitness",
				"business": "Business & Finance",
				"coaching": "Coaching & Skills",
				"consumer_goods": "Consumer goods",
				"digital_economy": "digital Economy",
				"divination": "Fortune telling",
				"economy": "Economy",
				"education": "Education & Employment",
				"energy": "Energy & Environment",
				"estate": "Immovable",
				"fashion": "Methods & Trends",
				"gardening": "Home & Gardening",
				"graphism": "Graphics & Design",
				"handworker": "Arts and crafts",
				"hobbies": "Hobbies and Interests",
				"industry": "Industry",
				"innovation": "Innovation, R & D",
				"insurance": "Insurance",
				"internet": "Internet",
				"low": "Law",
				"managment": "Management",
				"marketing": "Marketing & Sales",
				"media": "Media",
				"medical": "Medical",
				"personal_development": "Personal development",
				"resource_managment": "HR & Organization",
				"restoration": "Restoration",
				"sciences": "Science & Technology",
				"sport": "Sports",
				"strategy": "Strategy & Transformation",
				"sustainability": "Sustainable development",
				"tourism": "Travel & Tourism",
				"training": "Training",
				"web_development": "Web Development",
				"web_marketing": "Web marketing",
				"wellness": "Wellness & Health"
			}
		},
		"date": {
			"cancel": "To cancel",
			"clear": "Remove"
		},
		"delay": {
			"ranges": {
				"days": "Days)",
				"hours": "Hour (s)",
				"weeks": "Week (s)"
			}
		},
		"income": {
			"income": {
				"1": "less than 18K €",
				"2": "upper and lower 18K € 30K €",
				"3": "upper and lower 30K € 50K €",
				"4": "upper and lower 50K € 80K €",
				"5": "top € 80K and € 120K less",
				"6": "greater than 120K €"
			}
		},
		"minute": {
			"minutes": "minutes)"
		},
		"occupation": {
			"employees": "employees",
			"farmer": "operators farmers",
			"intermediate_profession": "Intermediate professions",
			"merchant": "Craftsmen, traders and business leaders",
			"no_occupation": "Other people without occupation",
			"retirees": "retirees",
			"upper_manager": "Executives and higher intellectual professions",
			"worker": "Workers"
		},
		"offertype": {
			"types": {
				"private": "private offer",
				"promotion": "Promotional offer",
				"public": "public offer"
			}
		},
		"phone": {
			"error": "This number is invalid"
		},
		"portfolio": {
			"labels": {
				"picture": "Photo",
				"video": "Video"
			},
			"video": {
				"button": "Add",
				"text": "You can add a video from YouTube or Vimeo",
				"url": "video uRL"
			}
		},
		"services": {
			"services": {
				"advertising": "Online Advertising",
				"audit": "Audit, Consulting and Education",
				"course": "Courses, Training, Orientation",
				"design": "Graphics and Design",
				"development": "Web development",
				"documents": "Production of Documents",
				"marketing": "Web marketing",
				"other": "Other",
				"other_service": "office visit",
				"receipe": "Recipes and Diet",
				"remote": "Remote service",
				"tourism": "teleconsultation"
			}
		},
		"servicetype": {
			"services": {
				"availability": "Consultation by chat",
				"mail": "Written consultation",
				"prepaid_minute": "Consultation by telephone",
				"product": "digital product",
				"service": "miscellaneous services"
			}
		},
		"timezone": {
			"timezones": {
				"Abu Dhabi": "(GMT + 04: 00) Abu Dhabi",
				"Adelaide": "(GMT + 09: 30) Adelaide",
				"Alaska": "(GMT-09: 00) Alaska",
				"Almaty": "(GMT + 06: 00) Almaty",
				"American Samoa": "(GMT-11: 00) American Samoa",
				"Amsterdam": "(GMT + 01: 00) Amsterdam",
				"Arizona": "(GMT-07: 00) Arizona",
				"Astana": "(GMT + 06: 00) Astana",
				"Athens": "(GMT + 02: 00) Athens",
				"Atlantic Time (Canada)": "(GMT-04: 00) Atlantic Time (Canada)",
				"Auckland": "(GMT + 12: 00) Auckland",
				"Azores": "(GMT-01: 00) Azores",
				"Baghdad": "(GMT + 03: 00) Baghdad",
				"Baku": "(GMT + 04: 00) Baku",
				"Bangkok": "(GMT + 07: 00) Bangkok",
				"Beijing": "(GMT + 08: 00) Beijing",
				"Belgrade": "(UTC + 01: 00) Belgrade",
				"Berlin": "(GMT + 01: 00) Berlin",
				"Bern": "(UTC + 01: 00) Bern",
				"Bogota": "(GMT-05: 00) Bogota",
				"Brasilia": "(GMT-03: 00) Brasilia",
				"Bratislava": "(UTC + 01: 00) Bratislava",
				"Brisbane": "(GMT + 10: 00) Brisbane",
				"Brussels": "(UTC + 01: 00) Brussels",
				"Bucharest": "(GMT + 02: 00) Bucharest",
				"Budapest": "(UTC + 01: 00) Budapest",
				"Buenos Aires": "(GMT-03: 00) Buenos Aires",
				"Cairo": "(GMT + 02: 00) Cairo",
				"Canberra": "(GMT + 10: 00) Canberra",
				"Cape Verde Is": [
					"(GMT-01: 00) Cape Verde Is."
				],
				"Caracas": "(GMT-04: 00) Caracas",
				"Casablanca": "(GMT + 00: 00) Casablanca",
				"Central America": "(GMT-06: 00) Central America",
				"Central Time (US & Canada)": "(GMT-06: 00) Central Time (US & Canada)",
				"Chatham Is": [
					"(GMT + 12: 45) Chatham Is."
				],
				"Chennai": "(GMT + 05: 30) Chennai",
				"Chihuahua": "(GMT-07: 00) Chihuahua",
				"Chongqing": "(GMT + 08: 00) Chongqing",
				"Copenhagen": "(UTC + 01: 00) Copenhagen",
				"Darwin": "(GMT + 09: 30) Darwin",
				"Dhaka": "(GMT + 06: 00) Dhaka",
				"Dublin": "(GMT + 00: 00) Dublin",
				"Eastern Time (US & Canada)": "(GMT-05: 00) Eastern Time (US & Canada)",
				"Edinburgh": "(GMT + 00: 00) Edinburgh",
				"Ekaterinburg": "(GMT + 05: 00) Ekaterinburg",
				"Fiji": "(GMT + 12: 00) Fiji",
				"Georgetown": "(GMT-04: 00) Georgetown",
				"Greenland": "(GMT-03: 00) Greenland",
				"Guadalajara": "(GMT-06: 00) Guadalajara",
				"Guam": "(GMT + 10: 00) Guam",
				"Hanoi": "(GMT + 07: 00) Hanoi",
				"Harare": "(GMT + 02: 00) Harare",
				"Hawaii": "(GMT-10: 00) Hawaii",
				"Helsinki": "(GMT + 02: 00) Helsinki",
				"Hobart": "(GMT + 10: 00) Hobart",
				"Hong Kong": "(GMT + 08: 00) Hong Kong",
				"Indiana (East)": "(GMT-05: 00) Indiana (East)",
				"International Date Line West": "(GMT-11: 00) International Date Line West",
				"Irkutsk": "(GMT + 08: 00) Irkutsk",
				"Islamabad": "(GMT + 05: 00) Islamabad",
				"Istanbul": "(GMT + 02: 00) Istanbul",
				"Jakarta": "(GMT + 07: 00) Jakarta",
				"Jerusalem": "(GMT + 02: 00) Jerusalem",
				"Kabul": "(GMT + 04: 30) Kabul",
				"Kamchatka": "(GMT + 12: 00) Kamchatka",
				"Karachi": "(GMT + 05: 00) Karachi",
				"Kathmandu": "(GMT + 05: 45) Kathmandu",
				"Kolkata": "(GMT + 05: 30) Kolkata",
				"Krasnoyarsk": "(GMT + 07: 00) Krasnoyarsk",
				"Kuala Lumpur": "(GMT + 08: 00) Kuala Lumpur",
				"Kuwait": "(GMT + 03: 00) Kuwait",
				"Kyiv": "(GMT + 02: 00) Kyiv",
				"La Paz": "(GMT-04: 00) La Paz",
				"Lima": "(GMT-05: 00) Lima",
				"Lisbon": "(GMT + 00: 00) Lisbon",
				"Ljubljana": "(UTC + 01: 00) Ljubljana",
				"London": "(GMT + 00: 00) London",
				"Madrid": "(UTC + 01: 00) Madrid",
				"Magadan": "(GMT + 11: 00) Magadan",
				"Marshall Is": [
					"(GMT + 12: 00) Marshall Is."
				],
				"Mazatlan": "(GMT-07: 00) Mazatlan",
				"Melbourne": "(GMT + 10: 00) Melbourne",
				"Mexico City": "(GMT-06: 00) Mexico City",
				"Mid-Atlantic": "(GMT-02: 00) Mid-Atlantic",
				"Midway Island": "(GMT-11: 00) Midway Island",
				"Minsk": "(GMT + 03: 00) Minsk",
				"Monrovia": "(GMT + 00: 00) Monrovia",
				"Monterrey": "(GMT-06: 00) Monterrey",
				"Montevideo": "(GMT-03: 00) Montevideo",
				"Moscow": "(GMT + 03: 00) Moscow",
				"Mountain Time (US & Canada)": "(GMT-07: 00) Mountain Time (US & Canada)",
				"Mumbai": "(GMT + 05: 30) Mumbai",
				"Muscat": "(GMT + 04: 00) Muscat",
				"Nairobi": "(GMT + 03: 00) Nairobi",
				"New Caledonia": "(GMT + 11: 00) New Caledonia",
				"New Delhi": "(GMT + 05: 30) New Delhi",
				"Newfoundland": "(GMT-03: 0-30) Newfoundland",
				"Novosibirsk": "(GMT + 07: 00) Novosibirsk",
				"Nuku'alofa": "(GMT +13: 00) Nuku'alofa",
				"Osaka": "(GMT + 09: 00) Osaka",
				"Pacific Time (US & Canada)": "(GMT-08: 00) Pacific Time (US & Canada)",
				"Paris": "(GMT + 01: 00) Paris",
				"Perth": "(GMT + 08: 00) Perth",
				"Port Moresby": "(GMT + 10: 00) Port Moresby",
				"Prague": "(GMT + 01: 00) Prague",
				"Pretoria": "(GMT + 02: 00) Pretoria",
				"Quito": "(GMT-05: 00) Quito",
				"Rangoon": "(GMT + 06: 30) Rangoon",
				"Riga": "(GMT + 02: 00) Riga",
				"Riyadh": "(GMT + 03: 00) Riyadh",
				"Rome": "(GMT + 01: 00) Rome",
				"Samoa": "(GMT + 13: 00) Samoa",
				"Santiago": "(GMT-04: 00) Santiago",
				"Sapporo": "(GMT + 09: 00) Sapporo",
				"Sarajevo": "(UTC + 01: 00) Sarajevo",
				"Saskatchewan": "(GMT-06: 00) Saskatchewan",
				"Seoul": "(GMT + 09: 00) Seoul",
				"Singapore": "(GMT + 08: 00) Singapore",
				"Skopje": "(UTC + 01: 00) Skopje",
				"Sofia": "(GMT + 02: 00) Sofia",
				"Solomon Is": [
					"(GMT + 11: 00) Solomon Is."
				],
				"Sri Jayawardenepura": "(GMT + 05: 30) Sri Jayawardenepura",
				"St": {
					" Petersburg": "(GMT + 03: 00) St. Petersburg"
				},
				"Stockholm": "(GMT + 01: 00) Stockholm",
				"Sydney": "(GMT + 10: 00) Sydney",
				"Taipei": "(GMT + 08: 00) Taipei",
				"Tallinn": "(GMT + 02: 00) Tallinn",
				"Tashkent": "(GMT + 05: 00) Tashkent",
				"Tbilisi": "(GMT + 04: 00) Tbilisi",
				"Tehran": "(GMT + 03: 30) Tehran",
				"Tijuana": "(GMT-08: 00) Tijuana",
				"Tokelau Is": [
					"(GMT + 13: 00) Tokelau Is."
				],
				"Tokyo": "(GMT + 09: 00) Tokyo",
				"UTC": "(GMT + 00: 00) UTC",
				"Ulaanbaatar": "(GMT + 08: 00) Ulaanbaatar",
				"Urumqi": "(GMT + 06: 00) Urumqi",
				"Vienna": "(UTC + 01: 00) Vienna",
				"Vilnius": "(GMT + 02: 00) Vilnius",
				"Vladivostok": "(GMT + 10: 00) Vladivostok",
				"Volgograd": "(GMT + 03: 00) Volgograd",
				"Warsaw": "(UTC + 01: 00) Warsaw",
				"Wellington": "(GMT + 12: 00) Wellington",
				"West Central Africa": "(GMT + 01: 00) West Central Africa",
				"Yakutsk": "(GMT + 09: 00) Yakutsk",
				"Yerevan": "(GMT + 04: 00) Yerevan",
				"Zagreb": "(UTC + 01: 00) Zagreb"
			}
		},
		"weekday": {
			"wday": [
				"Sunday",
				"On Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		}
	},
	"invitationform": {
		"labels": {
			"email": "E-mail",
			"password": "Password"
		},
		"hints": {
			"password": "Keep empty to automatically send an invite"
		},
		"submit": "Invite",
		"text": "Enter the email address of your new expert and celu ... r which he can connect and join your team",
		"title": "Invite a new expert"
	},
	"linkcreation": {
		"save": "Save",
		"title": "title",
		"url": "url"
	},
	"messenger": {
		"actions": {
			"createappointment": {
				"labels": {
					"day": "Day of appointment",
					"hour": "Appointment Time",
					"message": "Message"
				},
				"message": "Click the link below to accept an appointment with {nickname}",
				"next": "following",
				"select": "Share",
				"submit": "Share",
				"title": {
					"day": "Day",
					"default": "Suggest a meeting",
					"hour": "Hour",
					"message": "Message"
				}
			},
			"fileupload": {
				"labels": {
					"file": "Select my file"
				},
				"submit": "To send",
				"title": "Send a file"
			},
			"shareoffer": {
				"labels": {
					"message": "Message",
					"scope": "Type of offer"
				},
				"next": "following",
				"scopes": {
					"private": "private",
					"promotion": "Specials",
					"public": "public"
				},
				"select": "Share",
				"submit": "Share",
				"title": {
					"default": "Offering Sharing",
					"kind": "Type of offer",
					"message": "Message",
					"offer": "Offer"
				}
			},
			"sharepage": {
				"labels": {
					"message": "Message",
					"scope": "Category"
				},
				"next": "following",
				"select": "Share",
				"submit": "Share",
				"title": {
					"default": "Share a page",
					"kind": "Category",
					"message": "Message",
					"page": "Page"
				}
			}
		},
		"conversations": {
			"title": "Send a message"
		},
		"menu": {
			"actions": {
				"appointment": "Send appointments",
				"page": "Share a page",
				"share": "Share Offer",
				"upload": "Send a file"
			}
		},
		"more": "load more",
		"previews": {
			"offer": {
				"action": "See"
			}
		}
	},
	"minutegiftform": {
		"card": "Take my card",
		"labels": {
			"minutes": "Number of minutes",
			"reason": "Reason"
		},
		"offer": "To offer",
		"submit": "Give {minutes} minute (s) for {price} EUR",
		"text": "You are about to offer {minutes} minute (s) {price} EUR / min",
		"title": "Provide call minutes"
	},
	"outcometable": {
		"header": {
			"amount": "Price",
			"date": "Payment date",
			"id": "id",
			"status": "Status"
		}
	},
	"pages": {
		"account": {
			"tabs": {
				"bank": "Bank",
				"informations": "information",
				"profile": "Profile",
				"schedule": "Hours"
			}
		},
		"accounting": {
			"title": "Accounts"
		},
		"customization": {
			"addLink": "Add a link",
			"labels": {
				"color": {
					"primary": "main color",
					"secondary": "secondary color"
				},
				"favicon": "Favicon for your site",
				"feedbacks": "View Guest Reviews",
				"logo": "Your logo",
				"removePic": "Remove"
			},
			"links": "links footer",
			"save": "Save",
			"style": "Configure style"
		},
		"dashboard": {
			"title": {
				"availability": "Cat",
				"current": "In progress",
				"default": "My tasks",
				"mail": "mails",
				"pending": "Waiting",
				"phone": "call",
				"service": "Services"
			}
		},
		"expert": {
			"tabs": {
				"profile": "Profile",
				"purchases": "Features",
				"schedule": "Hours",
				"connection": "Connection"
			}
		},
		"expertgains": {
			"title": "Earnings"
		},
		"feedbacks": {
			"accepted": "accepted",
			"empty": "no opinion",
			"pending": "waiting",
			"rejected": "rejected"
		},
		"forgotpassword": {
			"labels": {
				"email": "E-mail",
				"platformName": "Url of your platform"
			},
			"login": "To log in",
			"reset": "Email instructions",
			"success": "An email was sent to you",
			"title": "Forgot your password"
		},
		"invitation": {
			"labels": {
				"confirmation": "Password Confirmation",
				"password": "Password",
				"terms": "Accept the Terms and the Privacy Policy"
			},
			"privacy": "Privacy Policy",
			"submit": "Accept",
			"terms": "Terms of use",
			"title": "Accept your invitation"
		},
		"login": {
			"forgotPassword": "Forgot your password",
			"labels": {
				"email": "E-mail",
				"password": "Password",
				"platformName": "url"
			},
			"login": "To log in",
			"title": "To log in"
		},
		"messengerwelcome": {
			"select": "Please select a conversation"
		},
		"notfound": {
			"text": "page nonexistent",
			"title": "404"
		},
		"platformrevenues": {
			"title": "Turnover"
		},
		"platformtraffic": {
			"title": "Site Information"
		},
		"purchases": {
			"title": "Shopping"
		},
		"resetpassword": {
			"forgot": "Resend the email",
			"labels": {
				"confirmation": "Password Confirmation",
				"password": "New Password"
			},
			"login": "To log in",
			"passwordTokenError": "Your code is not good, please send a new email",
			"submit": "change my password",
			"title": "Change my password pass"
		},
		"servicecreation": {
			"title": "Creating a Quotation"
		},
		"serviceedition": {
			"title": "Edition - {title}"
		},
		"setup": {
			"labels": {
				"birthday": "Date of Birth",
				"category": "Category",
				"firstName": "First name",
				"lastName": "Last name",
				"phone": "Phone number"
			},
			"submit": "safeguard",
			"title": "My information"
		},
		"statistics": {
			"average": "Average time",
			"call": "call",
			"chat": "cats",
			"collector": "Money collector",
			"email": "emails",
			"expert": "Expert",
			"gains": "Earnings",
			"minMax": "Min / max",
			"price_average": "average purchase price",
			"price_minute": "Price per minute",
			"product": "products",
			"service": "Services",
			"sum": "Total minutes",
			"title": "Statistics",
			"total": "Total calls"
		},
		"subscription": {
			"card": "My debit card",
			"cardDetails": "You use the card {alias} expires {month} / {year}",
			"current": "current plan",
			"next": "next payment",
			"noCard": "You do not have cards for your collection",
			"title": "My subscription",
			"updateCard": "Update my card"
		},
		"subscriptionpayment": {
			"inProgress": "Payment in progress",
			"pay": "Pay my subscription"
		},
		"team": {
			"header": {
				"actions": "Ranking",
				"email": "E-mail",
				"nickname": "Pseudo",
				"role": "Status"
			},
			"noDataText": "No expert",
			"noResultsText": "Some experts found",
			"roles": {
				"active": "Active",
				"inactive": "Inactive",
				"restricted": "narrow"
			},
			"title": "My team"
		},
		"teamavailabilities": {
			"average": "Average expert",
			"days": [
				"Sunday",
				"On Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			],
			"max": "Maximum per expert",
			"perDay": "Day",
			"perWeek": "Week",
			"title": "Availability of the team",
			"today": "total today"
		},
		"transfers": {
			"title": "my transfers"
		},
		"user": {
			"tabs": {
				"profile": "Profile",
				"purchases": "Features",
				"statistics": "Statistics"
			}
		},
		"users": {
			"search": "Search",
			"selected": "selectednext user | selected users",
			"title": "users"
		}
	},
	"purchase": {
		"appointment": {
			"accept": "Accepting the appointment",
			"refund": "Cancel appointment"
		},
		"availability": {
			"start": "Start Chat",
			"stop": "Stop"
		},
		"call": {
			"callee": "User",
			"caller": "Expert",
			"debug": "Details",
			"download": "Download the call",
			"downloadStart": "Your download will begin, this can take a few seconds before the download begins",
			"duration": "Call time",
			"error": "error occurred",
			"hangup": "To hang up",
			"hangupText": "To use this button make sure your phone ... tatus on the platform is always \"In consultation \"",
			"informations": "Information on Call",
			"none": "-",
			"pricePerMin": "Estimated price per minute",
			"starts": "Call date",
			"status": {
				"busy": "Busy",
				"canceled": "Canceled",
				"completed": "Finished",
				"failed": "Mistake",
				"in-progress": "In progress",
				"no-answer": "No answer",
				"queued": "During a call",
				"ringing": "During a call"
			},
			"statusLabel": "Status of the call",
			"timeLimit": "Maximum duration of call"
		},
		"callplayer": {
			"error": "No audio files associated",
			"title": "Heeding the Call"
		},
		"mail": {
			"accept": "Accept",
			"request": "Question:",
			"response": "Reply :",
			"responseForm": "Your answer"
		},
		"messageform": {
			"labels": {
				"content": "Reply",
				"title": "title"
			},
			"save": "Answer and end"
		},
		"refund": {
			"reason": "Describe a reason",
			"refund": "Cancel and refund",
			"refundText": "By canceling this service the customer will be refunded the purchase"
		},
		"service": {
			"accept": "Accept",
			"request": "Request :",
			"response": "Reply :",
			"responseForm": "Your answer"
		},
		"table": {
			"header": {
				"expert": "Expert",
				"fees": "Fresh",
				"id": "id",
				"offer": "Offer",
				"payedAt": "Payment date",
				"price": "Price",
				"total": "Total",
				"user": "Customer"
			},
			"noDataText": {
				"availability": "No cats",
				"default": "No shopping",
				"mail": "No emails",
				"phone": "No appeals",
				"prepaid_minute": "No packages",
				"product": "No product",
				"service": "No services"
			},
			"noResultsText": {
				"availability": "no cats",
				"default": "no purchases",
				"mail": "no emails",
				"phone": "no calls",
				"prepaid_minute": "no packages",
				"product": "Auncuns products",
				"service": "no services"
			},
			"rowsPerPageText": {
				"availability": "Cats per page",
				"default": "Purchases by page",
				"mail": "Emails per page",
				"phone": "Calls per page",
				"prepaid_minute": "Packages per page",
				"product": "Products by page",
				"service": "Services per page"
			},
			"scopes": {
				"all": "#VALUE!",
				"current": "In progress",
				"finished": "completed",
				"finished_with_cash_received_or_failed": "paid or stranded",
				"payed": "paid",
				"pending": "waiting",
				"refunded": "refunded",
				"with_cash_received": "paid"
			}
		},
		"title": {
			"appointment": "Appointment",
			"call": "call",
			"callStatus": {
				"busy": "Call busy with corresponding",
				"canceled": "call canceled",
				"error": "Call with error: {error}",
				"failed": "Call with error: {error}",
				"in-progress": "Call in progress",
				"no-answer": "Call not answered"
			},
			"perMin": "/ min"
		}
	},
	"refundedtag": {
		"refunded": "Canceled"
	},
	"service": {
		"actions": {
			"copy": "link copied",
			"edit": "Update"
		},
		"form": {
			"confirmDeletion": "Are you sure ?",
			"delete": "Remove",
			"errors": {
				"minutes": "The price of one minute must be at least {price} cents per minute"
			},
			"labels": {
				"availability--availabilityType": "Room Type",
				"availability--duration": "duration",
				"description": "Job description",
				"experts": "Experts béneficiant this offer",
				"expire": "Expiration date",
				"keywords": "Key word (separated by commas)",
				"mail--responseDelay": "Reply duration",
				"mail--wordCount": "Minimum number of words",
				"maxUserPurchase": "Maximum number of purchases per user (0 = unlimited)",
				"offerType": "Type of offer",
				"picture": "Image sharing",
				"portfolio": "portfolio",
				"prepaidMinute--minutes": "Number of minutes",
				"price": "Offer price",
				"product--message": "Message after purchasing your product",
				"service--responseDelay": "Reply duration",
				"service--serviceType": "Type of service",
				"serviceType": "Type of offer",
				"shortDescription": "Short description of the offer",
				"subtitle": "Subtitle supply (useful for sharing)",
				"title": "Title of your offer"
			},
			"save": "Save"
		},
		"meta": {
			"availability": "Cat",
			"mail": "Mail",
			"options": {
				"availability_type": "{value}",
				"days": "{value} day (s)",
				"duration": "{value} minute (s)",
				"hours": "{value} hour (s)",
				"minutes": "{value} minute (s)",
				"service_type": "{value}",
				"word_count": "{value} password (s)"
			},
			"phone": "Call",
			"prepaid_minute": "Flat rate",
			"product": "Product",
			"service": "Service",
			"services": {
				"advertising": "Online Advertising",
				"audit": "Audit, Consulting and Education",
				"course": "Courses, Training, Orientation",
				"design": "Graphics and Design",
				"development": "Web development",
				"documents": "Production of Documents",
				"marketing": "Web marketing",
				"other": "Other",
				"other_service": "office visit",
				"receipe": "Recipes and Diet",
				"remote": "Remote service",
				"tourism": "teleconsultation"
			}
		}
	},
	"sharecard": {
		"networks": {
			"facebook": "Facebook",
			"googleplus": "Google+",
			"linkedin": "LinkedIn",
			"twitter": "Twitter"
		}
	},
	"smartlink": {
		"add": "Add",
		"icon": "Icon",
		"save": "Save",
		"title": "title",
		"url": "URLs"
	},
	"transfer": {
		"addBank": "Update",
		"hints": {
			"amount": "Maximum € 2500 per transfer"
		},
		"labels": {
			"amount": "Transfer amount",
			"reference": "Reference"
		},
		"missingText": "You do not have information your bank information",
		"submit": "Transfer money",
		"text": "Transfer my money on my account {iban}",
		"title": "Transfer"
	},
	"transfertable": {
		"header": {
			"amount": "Price",
			"date": "Dated",
			"status": "state"
		},
		"noDataText": "No transfers",
		"noResultsText": "no transfers",
		"rowsPerPageText": "Transfers per page",
		"status": {
			"CREATED": "Waiting",
			"FAILED": "Failed",
			"SUCCEEDED": "Finished"
		}
	},
	"user": {
		"form": {
			"labels": {
				"email": "E-mail",
				"password": "Password",
				"passwordConfirmation": "Password Confirmation",
				"sendEmail": "Notify user"
			},
			"save": "Create"
		},
		"header": {
			"lock": "Block",
			"lockreason": "Due to the blockage",
			"messenger": "Send a message",
			"minute_gift": "Provide minutes",
			"more": "More",
			"risk": "enable monitoring",
			"riskreason": "Due to this change",
			"unlock": "unblock",
			"unlockreason": "Reason déblockage",
			"unrisk": "disable monitoring",
			"unriskreason": "Due to this change"
		},
		"import": {
			"labels": {
				"sendEmail": "Notify user"
			},
			"save": "Import"
		},
		"profile": {
			"item": {
				"createdAt": "account created",
				"email": "E-mail",
				"firstName": "First name",
				"lastConnection": "last connection",
				"lastName": "Last name",
				"lockedAt": "Blocked account",
				"minutes": "minutes remaining",
				"nickname": "Pseudo",
				"phone": "Phone",
				"riskyAt": "Monitor enabled"
			},
			"none": "-",
			"note": "Notes on the user",
			"save": "Save my notes",
			"subtitles": {
				"activity": "Activity",
				"contact": "Contact information",
				"other": "Other information",
				"personal": "Personal informations"
			}
		},
		"purchases": {
			"title": "completed services"
		},
		"search": {
			"clear": "Remove",
			"labels": {
				"email_cont": "E-mail",
				"first_name_cont": "First name",
				"last_name_cont": "Last name",
				"locked": "Only blocked users",
				"nickname_cont": "Pseudo",
				"phone_cont": "Phone number",
				"risky_at": "Only users risky"
			},
			"submit": "Search"
		},
		"statistics": {
			"purchaseHistory": "Purchase history",
			"purchasesAmount": "total spent",
			"purchasesAverage": "average purchase price",
			"purchasesTotal": "Shopping",
			"rates": "Notices given",
			"ratesAverage": "Average opinion",
			"ratesPending": "Waiting Notification"
		},
		"table": {
			"header": {
				"created_at": "Joined",
				"current_sign_in_at": "last connection",
				"email": "E-mail",
				"first_name": "First name",
				"last_name": "Last name",
				"nickname": "Pseudo",
				"payed_purchases_sum": "Spent",
				"phone_seconds_available": "Minutes"
			},
			"noDataText": "No users",
			"noResultsText": "some users",
			"rowsPerPageText": "Users per page",
			"selected": "selectednext user | selected users",
			"send": "Send a message",
			"sendToAll": "Message to all",
			"title": "users"
		}
	},
	"usermenu": {
		"actions": "stock",
		"addUser": "Add User",
		"export": "Export Users",
		"exportStarted": "Your export is in progress, you will receive an email once the export is complete",
		"import": "Upload users",
		"send": "Send a message",
		"sendToAll": "Message to all"
	},
	"wallet": {
		"title": "money available",
		"transfer": "To transfer"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 745
// module chunks = 32